import { Injectable } from '@angular/core';
import { RestProviderService } from '../rest-provider/rest-provider.service';
import { DynamicLoadingUtil } from '../../shared/helpers/dynamic-loading-util';
import { RequestModel } from '../../models/request/request-model';
import { Observable, throwError, BehaviorSubject, lastValueFrom, firstValueFrom } from 'rxjs';
import { map, filter, switchMap, catchError } from 'rxjs/operators';
import { PaginationModel } from 'src/app/models/search/pagination.model';
import { ProjectionFacetWrapperModel } from 'src/app/models/search/facet-projection-wrapper.model';
import { AdditionalSearchSettingsModel } from 'src/app/models/search/additional-search-settings.model';
import { Router } from '@angular/router';
import { SearchRightInfoModel } from '../../models/search/search-right-info-model';
import { parse } from 'path';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { count } from 'console';
import { add } from 'lodash';


@Injectable({
  providedIn: 'root'
})
export class SearchService {


  currentPreviewItemClicked = null;
  searchState: any = null;
  historySearchStateAdditionalFields: any = null;
  historySearchState: any = null;
  historySearchLatestFacets: any = null;
  historySearchMainSearchFieldValue: any = null;
  globalSearch: boolean = false;
  globalSearchType: string;

  splitSearchEnabled: boolean = false;
  splitSearchKeywords: any[] = [];

  facetsOrder: any[] = [];

  // settings for data grid and search component
  pageSize: number = 5;
  public currentPlaceHoldertitle: string;
  private searchRightInfo: Observable<SearchRightInfoModel[]>; // store the shared observable
  private searchRightInfoResponse: SearchRightInfoModel[];

  private defaultSearchUrl: string = "api/data/list";
  // search results
  private search: Observable<any[]>; // store the shared observable
  // search results semantic
  private searchSemantic: Observable<any>; // store the shared observable

  // projection and initial facets
  private searchProjectionAndFacets = new BehaviorSubject<ProjectionFacetWrapperModel>(undefined);
  currentSearchProjectionAndFacets = this.searchProjectionAndFacets.asObservable();

  // listener for search value change
  private newSearchValue = new BehaviorSubject(undefined);
  currentSearchValue = this.newSearchValue.asObservable();

  // listener for search pagination
  private pagination = new BehaviorSubject<PaginationModel>(undefined);
  currentPagination = this.pagination.asObservable();

  // listener for search page
  private searchPage = new BehaviorSubject(undefined);
  currentSearchPage = this.searchPage.asObservable();

  // listener for search facets - current facets that are included in search request
  private searchFacets = new BehaviorSubject(undefined);
  currentSearchFacets = this.searchFacets.asObservable();

  // facets that are availible for filtering on current listing page
  private availibleFacets = new BehaviorSubject(undefined);
  currentAvailibleFacets = this.availibleFacets.asObservable();

  // metamodel
  private metamodel = new BehaviorSubject(undefined);
  currentMetaModel = this.metamodel.asObservable();

  // sort field
  private sortFields = new BehaviorSubject(undefined);
  currentSortFields = this.sortFields.asObservable();

  // for enabling facets
  private enableFacets = new BehaviorSubject(undefined);
  currentEnableFacets = this.enableFacets.asObservable();

  // for additional search settings
  private additionalSearchSettings = new BehaviorSubject<AdditionalSearchSettingsModel>(undefined);
  currentAdditionalSearchSettings = this.additionalSearchSettings.asObservable();

  // listener for search event (if search was executed)
  private searchExecuted = new BehaviorSubject(undefined);
  currentSearchExecuted = this.searchExecuted.asObservable();


  private gridRestoredDefault = new BehaviorSubject(undefined);
  currentgridRestoredDefault = this.gridRestoredDefault.asObservable();

  private searchFieldsRestoredDefault = new BehaviorSubject(undefined);
  currentsearchFieldsRestoredDefault = this.searchFieldsRestoredDefault.asObservable();

  // listener for search event (if search was executed)
  private userSearchSettings = new BehaviorSubject(undefined);
  currentUserSearchSettings = this.userSearchSettings.asObservable();

  // listener for changing page size
  private pageS = new BehaviorSubject(undefined);
  currentPageSize = this.pageS.asObservable();

  // listener for split search
  splitSearchS = new BehaviorSubject(undefined);
  splitSearch = this.splitSearchS.asObservable();

  // current search query  
  private currentSearchQuery = null;
  // current data grid display fields
  private currentGridDisplayFields = null;

  private currentCheckedBulkDocuments = null;

  constructor(private restProviderService: RestProviderService, private router: Router, private httpClient: HttpClient) {
  }

  setGridRestoredDefault(value) {
    this.gridRestoredDefault.next(value);
  }

  setSearchFieldsRestoredDefault(value) {
    this.searchFieldsRestoredDefault.next(value);
  }

  setEnableFacets(enable: boolean) {
    this.enableFacets.next(enable);
  }

  setAdditionalSearchSettings(settings: AdditionalSearchSettingsModel) {
    this.additionalSearchSettings.next(settings);
  }

  searchPerformed() {
    this.searchExecuted.next(true);
  }

  changeCurrentSearchSettings(currentSearchSettings: any, control: string) {
    this.userSearchSettings.next(
      {
        "Control": control,
        "Settings": currentSearchSettings
      });
  }

  changeSortFields(sortFields: any) {
    this.sortFields.next(sortFields);
  }

  changePageSize(pagesize: number) {
    if (pagesize != null && typeof pagesize != "undefined") {
      this.pageSize = pagesize;
      this.pageS.next(pagesize);
    }
  }

  changeMetaModelEntities(metamodel: any) {
    this.metamodel.next(metamodel);
  }

  changeAvailibleFacets(facets: any) {
    this.availibleFacets.next(facets);
  }

  changeSearchFacets(facets: any) {
    this.searchFacets.next(facets);
  }

  setCurrentSearchQuery(searchQuery: any) {
    this.currentSearchQuery = searchQuery;
  }

  getCurrentSearchQuery() {
    return this.currentSearchQuery;
  }

  setCurrentCheckedBulkDocuments(currentCheckedBulkDocs: any[]) {
    this.currentCheckedBulkDocuments = currentCheckedBulkDocs;
  }

  getCurrentCheckedBulkDocument() {
    return this.currentCheckedBulkDocuments;
  }

  setCurrentGridDisplayFields(displayFields: any[]) {
    this.currentGridDisplayFields = displayFields;
  }

  getCurrentGridDisplayFields() {
    return this.currentGridDisplayFields;
  }

  changeSearchPage(pageNum: any) {
    if (pageNum == null || typeof pageNum == "undefined") {
      this.searchPage.next(undefined);
    } else {
      this.searchPage.next(pageNum + "");
    }
  }

  changeSearchProjectionAndFacets(projectionAndFacets: ProjectionFacetWrapperModel) {
    this.searchProjectionAndFacets.next(projectionAndFacets);
  }

  changePaginationInfo(paginationInfo: PaginationModel) {
    this.pagination.next(paginationInfo);
  }

  historySearchStatePresent(query: any) {
    if (this.historySearchState != null && this.historySearchState["query"] != null && this.historySearchState["query"].data != null) {
      if (this.historySearchState["query"].data.ClassTypes[0] == query.ClassTypes[0] && this.historySearchState["url"] == window.location.href) {
        return true;
      }
    }
    return false;
  }

  getHistoryMainSearchFieldValue() {
    return this.historySearchMainSearchFieldValue;
  }

  getHistorySearchAdditionalFields() {
    let addFieldsHistory = [];

    if (this.historySearchStateAdditionalFields != null && typeof this.historySearchStateAdditionalFields != "undefined" && this.historySearchStateAdditionalFields.length > 0) {
      for (var i = 0; i < this.historySearchStateAdditionalFields.length; i++) {
        // add only those with searchvalues (because we need to show them on ui - biding)
        if (this.historySearchStateAdditionalFields[i].SearchValue != null && typeof this.historySearchStateAdditionalFields[i].SearchValue != "undefined" && this.historySearchStateAdditionalFields[i].SearchValue.length > 0) {
          addFieldsHistory.push(
            {
              "Binding": this.historySearchStateAdditionalFields[i].Name,
              "Value": this.historySearchStateAdditionalFields[i].SearchValue
            });
        } else if (this.historySearchStateAdditionalFields[i]["CheckBoxState"] != null && typeof this.historySearchStateAdditionalFields[i]["CheckBoxState"] != "undefined" && this.historySearchStateAdditionalFields[i]["CheckBoxState"] != "novalue") {
          addFieldsHistory.push(
            {
              "Binding": this.historySearchStateAdditionalFields[i].Name,
              "Value": this.historySearchStateAdditionalFields[i]["CheckBoxState"]
            });

        } else if ((typeof this.historySearchStateAdditionalFields[i]["SearchValueFrom"] != "undefined" && this.historySearchStateAdditionalFields[i]["SearchValueFrom"] != "")
          || (typeof this.historySearchStateAdditionalFields[i]["SearchValueTo"] != "undefined" && this.historySearchStateAdditionalFields[i]["SearchValueTo"] != "")) {

          var from = "*";
          var to = "*";

          if (typeof this.historySearchStateAdditionalFields[i]["SearchValueFrom"] != "undefined" && this.historySearchStateAdditionalFields[i]["SearchValueFrom"] != "" && this.historySearchStateAdditionalFields[i]["SearchValueFrom"] != null) {
            from = this.historySearchStateAdditionalFields[i]["SearchValueFrom"];
          }

          if (typeof this.historySearchStateAdditionalFields[i]["SearchValueTo"] != "undefined" && this.historySearchStateAdditionalFields[i]["SearchValueTo"] != "" && this.historySearchStateAdditionalFields[i]["SearchValueTo"] != null) {
            to = this.historySearchStateAdditionalFields[i]["SearchValueTo"];
          }

          addFieldsHistory.push(
            {
              "Binding": this.historySearchStateAdditionalFields[i].Name,
              "ValueFrom": from,
              "ValueTo": to
            });
        }
      }
    }

    return addFieldsHistory;
  }

  performSearch(query: any, customSearchUrl: string, additionalFieldsInfo: any, mainSearchValue: any) {

    let searchUrl = this.defaultSearchUrl;

    if (customSearchUrl != null && typeof customSearchUrl != "undefined" && customSearchUrl.trim() != "") {
      searchUrl = customSearchUrl;
    }

    var reqModel = new RequestModel;

    if (this.historySearchState != null && this.historySearchState["query"] != null && this.historySearchState["query"].data != null) {
      if (this.historySearchState["query"].data.ClassTypes[0] == query.ClassTypes[0] && this.historySearchState["url"] == window.location.href) {
        reqModel = this.historySearchState["query"];
      } else {
        reqModel.url = searchUrl;
        reqModel.data = query;
        this.searchState = reqModel;
        this.historySearchStateAdditionalFields = additionalFieldsInfo;
        this.historySearchMainSearchFieldValue = mainSearchValue;
      }
    } else {
      reqModel.url = searchUrl;
      reqModel.data = query;
      this.searchState = reqModel;
      this.historySearchStateAdditionalFields = additionalFieldsInfo;
      this.historySearchMainSearchFieldValue = mainSearchValue;
    }

    this.search = this.restProviderService.getDataPOST<any[]>(reqModel).
      pipe(
        map((data: any[]) => {
          this.historySearchState = null;
          return data;
        }), catchError((error: any) => {
          //Observable.throw('Error while retrieving data from the server - ' + (error.json().errorMessage || 'Server error'))
          throw Observable.create(error);
        }
        ));


    return this.search;

  }

  performSemanticSearch(query: any) {
    
    var reqModel = new RequestModel;
    reqModel.url = this.defaultSearchUrl;
    reqModel.data = query;

    this.searchSemantic = this.restProviderService.getDataPOST<any>(reqModel)
    .pipe(
      map((data: any) => {             
        return data; 
      }), 
      catchError((error: any) => {            
        return throwError(() => error); 
      })
    );

  return this.searchSemantic;

  }

  getAllowedSearchClasses(searchType: string) {

    var reqModel = new RequestModel;
    reqModel.url = "/api/user/allowedsearchclass";
    reqModel.data = {
      "GlobalSearchType": searchType
    }

    this.searchRightInfo = this.restProviderService.getDataPOST<SearchRightInfoModel[]>(reqModel).
      pipe(
        map((data: SearchRightInfoModel[]) => {
          this.searchRightInfoResponse = data;
          return data;
        }), catchError(error => {
          return throwError('User service error!', error)
        }));

    return this.searchRightInfo;
  }

  changeSearchValue(value: any) {
    this.newSearchValue.next(value);
  }

  setLatestHistorySearchFacets(currentFacets, classType, url) {
    this.historySearchLatestFacets =
    {
      "Facets": currentFacets,
      "url": url,
      "classType": classType
    };

    return this.historySearchLatestFacets;
  }

  parseQueryBuilder(query, config, upperQuery, counter: number = 0) {
    if (query !== null && query !== undefined) {

      if (query.condition !== null && query.condition === "and" || query.condition === "or") {

        // if condition present in query then it's ruleset
        const treeQueryWithSubQ = { Type: query.condition.toUpperCase(), SubQueries: [] };

        if (query.rules !== null && query.rules.length > 0) {
          // go through each subquery and parse recursevly
          for (let i = 0; i < query.rules.length; i++) {
            counter++;
            const returnedQ = this.parseQueryBuilder(query.rules[i], config, treeQueryWithSubQ, counter);

            if (returnedQ !== null) {
              // add subquery to current subqueries
              treeQueryWithSubQ.SubQueries.push(returnedQ);
            }

          }
        }

        return treeQueryWithSubQ;
      }
      else if ((query.condition === undefined || query.condition === null) && query.field !== null) {
        // if condition is null and field present then normal fieldvalue,fieldrange query
        const queryField = query.field;
        // this is convention for now
        let queryFieldNameForSearch = queryField.replaceAll("$$", ".");

        // get configuration
        const queryFieldConfiguration = config.fields[queryField];

        if (queryFieldConfiguration !== null && queryFieldConfiguration !== undefined) {
          const queryFieldType = queryFieldConfiguration.type;

          if (queryFieldType !== null && queryFieldType !== undefined) {

            //string field
            if (queryFieldType === "string") {

              let fieldValueQ = query.value;
              if (!fieldValueQ.endsWith("*")) {
                fieldValueQ += "*";
              }

              const fieldValueQuery = { Type: "FieldValue", FieldName: queryFieldNameForSearch, FieldValue: fieldValueQ };

              // XXX: handle operators
              // for now just = and !=
              switch (query.operator.Value) {
                case "!=":
                  fieldValueQuery["Negate"] = true;
                  break;
              }


              return fieldValueQuery;

            }
            // range fields
            else if (queryFieldType === "number" || queryFieldType === "date" || queryFieldType === "time") {

              if(queryFieldType === "date" && query.operator && query.operator.Value == "empty"){
                // careful here: "emptydate" value must match same value in backend (so if you change here, also change in backend or viceversa)
                return { Type: "FieldValue", FieldName: queryFieldNameForSearch, "FieldValue": "emptydate" };              
              }else if(queryFieldType === "number" && query.operator && query.operator.Value == "curr_user"){
                return { Type: "FieldValue", FieldName: queryFieldNameForSearch, "FieldValue": "{{this.restProviderService.currentUser.Id}}" };              
              }else{
                let isNumberType = false;
                if (queryFieldType === "number") {
                  isNumberType = true;
                }
  
                let rangeValueTo = null;
                let rangeValueFrom = null;
  
                let fieldRangeQuery = { Type: "FieldRange", FieldName: queryFieldNameForSearch };
  
                switch (query.operator.Value) {
                  case ">":
  
                    rangeValueTo = "*";
  
                    if (isNumberType) {
                      rangeValueFrom = query.value + 1;
                    } else {
                      // convert to date + add 1 day
                      rangeValueFrom = "#AddDays('" + query.value + "',1)#";
                    }
  
                    break;
  
                  case "=>":
  
                    rangeValueTo = "*";
                    rangeValueFrom = query.value;
  
                    break;
  
                  case "<":
  
                    rangeValueFrom = "*";
  
                    if (isNumberType) {
                      rangeValueTo = query.value - 1;
                    } else {
                      // convert to date and minus 1 day
                      rangeValueTo = "#AddDays('" + query.value + "',-1)#";
                    }
  
                    break;
  
                  case "<=":
  
                    rangeValueTo = query.value;
                    rangeValueFrom = "*"
  
                    break;
                  case "=":
  
                    rangeValueFrom = query.value;
                    rangeValueTo = query.value;
  
                    break;
                  case "!=":
  
                    rangeValueFrom = query.value;
                    rangeValueTo = query.value;
                    fieldRangeQuery["Negate"] = true;
  
                    break;
                }
  
                if (rangeValueFrom !== null && rangeValueFrom !== undefined && rangeValueTo !== null && rangeValueTo !== undefined) {
                  fieldRangeQuery["FieldValueFrom"] = rangeValueFrom;
                  fieldRangeQuery["FieldValueTo"] = rangeValueTo;
  
                  return fieldRangeQuery;
                } else {
                  return null;
                }
              }              
            }
            // checkbox
            else if (queryFieldType === "boolean") {
              // for boolean(checkbox) we dont need to handle operators since there is only one operator ("=")
              let boolValue = false;
              if (query.value !== null && query.value !== undefined) {
                boolValue = query.value;
              }

              const fieldValueQuery = { Type: "FieldValue", FieldName: queryFieldNameForSearch, FieldValue: boolValue };
              return fieldValueQuery;
            }
            // dropdown 
            else if (queryFieldType === "category") {

              let dropDownValueId = 0;
              if (query.value !== null && query.value["Id"] !== null) {
                dropDownValueId = query.value["Id"];
              }

              let fieldValueCategoryQuery = { Type: "FieldValue", FieldName: queryFieldNameForSearch + ".Id", FieldValue: dropDownValueId };

              if (query.operator.Value === "!=") {
                fieldValueCategoryQuery["Negate"] = true;
              }

              return fieldValueCategoryQuery;

            }
            // multiple search fields control
            else if (queryFieldType === "multiplesearchfield"){


              let andQueryMultiple: any = 
              {
                Type: "AND",
                SubQueries: []
              }

              if(queryFieldConfiguration && queryFieldConfiguration.settings){
                for(let column of queryFieldConfiguration.settings.Columns){
                  if(column && column.Rows){
                    for(let row of column.Rows){

                      const propertyBinding = row["PropertyBinding"];
  
                      if(query[propertyBinding]){
                        let objVal = query[propertyBinding];
                        let valFrom = objVal["SearchValueFrom"];

                        if (valFrom && valFrom.trim().length > 0){
                          let queryMultiple:any = {                            
                            FieldName:propertyBinding.replaceAll("_", "."),     
                            // need this for backward mapping -> TreeQuery to QueryBuilder in view settings 
                            IsMultipleField: true,         
                            QueryBuilderMultipleSearchFieldName:query.field,
                            QueryBuilderFieldTrackingKey: query.field + "" + counter                                  
                          }

                          if(query.operator.Value === "!=" || query.operator.Value === "="){
                            queryMultiple.Type = "FieldValue";
                            queryMultiple.FieldValue = valFrom;
                          }else if(query.operator.Value === "=>"){
                            queryMultiple.Type = "FieldRange";
                            queryMultiple.FieldValueFrom = valFrom;
                            queryMultiple.FieldValueTo = "*";
                          }else if(query.operator.Value === "<="){
                            queryMultiple.Type = "FieldRange";
                            queryMultiple.FieldValueTo = valFrom;
                            queryMultiple.FieldValueFrom = "*";
                          }

                          if(query.operator.Value === "!="){
                            queryMultiple.Negate = true;
                          }
                          //andQueryMultiple.SubQueries.push(queryMultiple);
                          if(upperQuery && upperQuery.SubQueries){
                            upperQuery.SubQueries.push(queryMultiple);
                          }
                        }

                      }
                    }
                  }
                }
              }              

              /*if(andQueryMultiple.SubQueries.length > 0){
                return andQueryMultiple;
              }*/
              return null;
            }
          }
        }

      }
    }

    return null;
  }

  async parseTreeQueryToQueryBuilder(treeQuery, queryBuilderConfig, depth, queryModelParam, queryBuilderTrackingKeys: any = {}){
    
    if(treeQuery){

      if(treeQuery.SubQueries && treeQuery.SubQueries.length > 0){

        /*let queryModel: any = null;

        if(queryModelParam != null && typeof queryModelParam != "undefined"){
          
          queryModel = queryModelParam;       

        }else{
          queryModel = {
            "condition": treeQuery.Type.toLocaleLowerCase(),
            "rules": []
          };         
        } */
       let queryModel: any = {
          "condition": treeQuery.Type.toLocaleLowerCase(),
          "rules": []
        };                

        for(let i = 0; i < treeQuery.SubQueries.length; i++){

          let treeQuerySub = treeQuery.SubQueries[i];
          let parsedQueryB = await this.parseTreeQueryToQueryBuilder(treeQuerySub, queryBuilderConfig, depth + 1, queryModel, queryBuilderTrackingKeys);

          if(parsedQueryB){
            queryModel.rules.push(parsedQueryB);
          }
        }

        return queryModel;                      

      }else if(treeQuery.Type && treeQuery.Type.length > 0 && treeQuery.FieldName && treeQuery.FieldName.length > 0){
        
        if(treeQuery.IsMultipleField === true){
          let queryBuilderFieldName = treeQuery.QueryBuilderMultipleSearchFieldName;
          let queryFieldConfiguration = queryBuilderConfig.fields[queryBuilderFieldName];        

          let ruleToAdd = {
            "field": queryBuilderFieldName,
            "trackingKey": treeQuery.QueryBuilderFieldTrackingKey
          }; 

          if (treeQuery.Type == "FieldValue"){ 

            let ruleIndex = -1;
            // special for RangeQuery in multiplefield
            if(queryModelParam && queryModelParam.rules){
              ruleIndex = queryModelParam.rules.findIndex(x => x.field === queryBuilderFieldName && x.trackingKey == treeQuery.QueryBuilderFieldTrackingKey);              
            }


            if(ruleIndex >= 0){              
              queryModelParam.rules[ruleIndex][treeQuery.FieldName] = {"SearchValueFrom": treeQuery.FieldValue};           

              // null so we wont add another subquery to it, we just modify existing rule
              return null;
            }else{
              ruleToAdd["operator"] = queryFieldConfiguration.operators.find(x => x.Value == '=');            
              ruleToAdd[treeQuery.FieldName] = {"SearchValueFrom": treeQuery.FieldValue};            
  
              if(queryFieldConfiguration.settings && queryFieldConfiguration.settings.Columns){
                for(let column of queryFieldConfiguration.settings.Columns){
                  if(column && column.Rows){
                    for(let row of column.Rows){
    
                      const propertyBinding = row["PropertyBinding"];
    
                      if (!ruleToAdd[propertyBinding]){
                        ruleToAdd[propertyBinding] = {"SearchValueFrom": ""};
    
                      }
                     
                    }
                  }
                }
              } 
            }                      

          } else if (treeQuery.Type == "FieldRange"){

            let ruleIndex = -1;
            // special for RangeQuery in multiplefield
            if(queryModelParam && queryModelParam.rules){
              ruleIndex = queryModelParam.rules.findIndex(x => x.field === queryBuilderFieldName && x.trackingKey == treeQuery.QueryBuilderFieldTrackingKey);              
            }               

            if(ruleIndex >= 0){              

              if (treeQuery.FieldValueTo && treeQuery.FieldValueTo === "*") {                
                queryModelParam.rules[ruleIndex][treeQuery.FieldName] = {"SearchValueFrom": treeQuery.FieldValueFrom};                
              } else if(treeQuery.FieldValueFrom && treeQuery.FieldValueFrom === "*") {                
                queryModelParam.rules[ruleIndex][treeQuery.FieldName] = {"SearchValueFrom": treeQuery.FieldValueTo};            
              }

              // null so we wont add another subquery to it, we just modify existing rule
              return null;
            }else{
              if (treeQuery.FieldValueTo && treeQuery.FieldValueTo === "*") {
                ruleToAdd["operator"] = queryFieldConfiguration.operators.find(x => x.Value == '=>');            
                ruleToAdd[treeQuery.FieldName] = {"SearchValueFrom": treeQuery.FieldValueFrom};                              
              } else if(treeQuery.FieldValueFrom && treeQuery.FieldValueFrom === "*") {
                ruleToAdd["operator"] = queryFieldConfiguration.operators.find(x => x.Value == '<=');            
                ruleToAdd[treeQuery.FieldName] = {"SearchValueFrom": treeQuery.FieldValueTo};              
              }              
  
              if(queryFieldConfiguration.settings && queryFieldConfiguration.settings.Columns){
                for(let column of queryFieldConfiguration.settings.Columns){
                  if(column && column.Rows){
                    for(let row of column.Rows){
    
                      const propertyBinding = row["PropertyBinding"];
    
                      if (!ruleToAdd[propertyBinding]){
                        ruleToAdd[propertyBinding] = {"SearchValueFrom": ""};
    
                      }
                     
                    }
                  }
                }
              }   

            }              
          }

          if(depth == 1){              
            return {
              "condition": "and",
              "rules": [ruleToAdd]
            }; 
  
          }else{
            
            return ruleToAdd;        
  
          } 

        }else{
          let queryBuilderFieldName = treeQuery.FieldName.replaceAll(/\./g, "$$$$");
          // get configuration
          let queryFieldConfiguration = queryBuilderConfig.fields[queryBuilderFieldName];        
          let isDropdown = false;
  
          if (queryFieldConfiguration == null || typeof queryFieldConfiguration == "undefined" && queryBuilderFieldName.endsWith("$$Id")){
            // try without last property (in some cases this is correct)
            queryBuilderFieldName = queryBuilderFieldName.substring(0, queryBuilderFieldName.length - 4);
            // get configuration
            queryFieldConfiguration = queryBuilderConfig.fields[queryBuilderFieldName];   
            // we can assume this is dropdown
            isDropdown = true;
          }
  
          let ruleToAdd = {
            "field": queryBuilderFieldName
          };        
  
          if(treeQuery.Type == "FieldValue"){        
              
            if(treeQuery.FieldValue === "emptydate"){
              ruleToAdd["operator"] = queryFieldConfiguration.operators.find(x => x.Value == 'empty');            
              ruleToAdd["value"] = treeQuery.FieldValue;
            
            }else if(treeQuery.FieldValue === "{{this.restProviderService.currentUser.Id}}"){
              ruleToAdd["operator"] = queryFieldConfiguration.operators.find(x => x.Value == 'curr_user');            
              ruleToAdd["value"] = "curr_user";
            }else{
              if (typeof treeQuery.FieldValue === 'string' && treeQuery.FieldValue.endsWith('*')) {
                // Remove the last '*' if it exists
                treeQuery.FieldValue = treeQuery.FieldValue.slice(0, -1);
              }     
    
    
              if(isDropdown === true){
                // we must also get title so it can show in UI query builder
                // so we will retrieve registry value from api
                let galregname = queryFieldConfiguration.galregname;
    
                const query = {
                  "ClassTypes": [galregname],
                  "Page":1,
                  "PageSize":1,
                  "RepositoryName":"nhibernate",
                  "Projection":["Title","Id"],
                  "TreeQuery":{
                    "Type":"FieldValue",
                    "FieldName":"Id",
                    "FieldValue": treeQuery.FieldValue
                  }
                };
    
                const headers = new HttpHeaders({
                  'Authorization': 'Bearer ' + this.restProviderService.getToken()
                });
                
                let response_reg = await firstValueFrom(this.httpClient.post(environment.wgProfileHost + "/api/data/list", query, { headers }));
                
                if(response_reg && response_reg["Models"]){
                  
                  let model_response = response_reg["Models"][0];
    
                  if(model_response && model_response.Model){
                    ruleToAdd["value"] = {
                      "Id":model_response.Model.Id,
                      "Title":model_response.Model.Title              
                    };
                  }              
                }                 
              }else{
                ruleToAdd["value"] = treeQuery.FieldValue;     
              }
              
    
              try {
                if (treeQuery.FieldValue && typeof treeQuery.FieldValue === 'string' && treeQuery.FieldValue.includes("{{")) {
                  var evalString = treeQuery.FieldValue.substring(treeQuery.FieldValue.lastIndexOf("{{") + 2,treeQuery.FieldValue.lastIndexOf("}}"));    
                  try {
                    var res = eval(evalString);
          
                    if (typeof res != "undefined" && res) {
                      ruleToAdd["value"] = res;                  
                    }
                    else {
                      ruleToAdd["value"] = "*";
                    }
                  } catch (e) {
                    ruleToAdd["value"] = "*";                
                  }
                }            
              } catch (e) {            
                ruleToAdd["value"] = "*"
              }
    
              if(treeQuery.Negate && treeQuery.Negate === true){
                ruleToAdd["operator"] = queryFieldConfiguration.operators.find(x => x.Value == '!=');
              }else{
                if(treeQuery.FieldValue === true || treeQuery.FieldValue === false){
                  // boolean fields have "=" operator
                  ruleToAdd["operator"] = queryFieldConfiguration.operators.find(x => x.Value == '=');            
                }else if(typeof treeQuery.FieldValue !== 'string'){
                  // integer field values
                  ruleToAdd["operator"] = queryFieldConfiguration.operators.find(x => x.Value == '=');                        
                }else{
                  ruleToAdd["operator"] = queryFieldConfiguration.operators.find(x => x.Value.toLocaleLowerCase() == 'contains');            
                }            
              }     
            }               
  
          }else if (treeQuery.Type == "FieldRange"){
            if(treeQuery.FieldValueFrom === "*"){            
  
              let isNumberField = true;
              if (typeof treeQuery.FieldValueTo === 'string') {
                isNumberField = false;
              }
  
              if(isNumberField || !treeQuery.FieldValueTo.includes("AddDays")){
                
                ruleToAdd["operator"] = queryFieldConfiguration.operators.find(x => x.Value == '<=');            
                ruleToAdd["value"] = treeQuery.FieldValueTo;
  
              }else if(treeQuery.FieldValueTo.includes("AddDays")){
                
                ruleToAdd["operator"] = queryFieldConfiguration.operators.find(x => x.Value == '<');            
                let extractedValue = this.extractDateFromAddDays(treeQuery.FieldValueTo);
                if(extractedValue){
                  ruleToAdd["value"] = extractedValue;
                }
  
              }
  
              
            }else if(treeQuery.FieldValueTo == "*"){            
  
              let isNumberField = true;
              if (typeof treeQuery.FieldValueFrom === 'string') {
                isNumberField = false;
              }
  
              if(isNumberField || !treeQuery.FieldValueFrom.includes("AddDays")){
  
                ruleToAdd["operator"] = queryFieldConfiguration.operators.find(x => x.Value == '=>'); 
                ruleToAdd["value"] = treeQuery.FieldValueFrom;                         
  
              }else if(treeQuery.FieldValueFrom.includes("AddDays")){
                              
                ruleToAdd["operator"] = queryFieldConfiguration.operators.find(x => x.Value == '>'); 
                let extractedValue = this.extractDateFromAddDays(treeQuery.FieldValueFrom);
                if(extractedValue){
                  ruleToAdd["value"] = extractedValue;
                }
  
              }
  
            }else if(treeQuery.FieldValueTo == treeQuery.FieldValueFrom){
  
              if(treeQuery.Negate === true){
                ruleToAdd["operator"] = queryFieldConfiguration.operators.find(x => x.Value == '!='); 
              }else{
                ruleToAdd["operator"] = queryFieldConfiguration.operators.find(x => x.Value == '='); 
              }
              ruleToAdd["value"] = treeQuery.FieldValueFrom;       
            }
            
          }
  
          if(depth == 1){
  
            return {
              "condition": "and",
              "rules": [ruleToAdd]
            }; 
  
          }else{
            
            return ruleToAdd;        
  
          } 
        }               
      }

    }    
  }

  // this is parsing view settings dialog sorting model to WG backend sorting
  parseViewSettingsSortingForBackend(sortingFields: any[], rootClassName){
    let parsedStructure: any[] = [];

    if(sortingFields && sortingFields.length > 0 && rootClassName && rootClassName.length > 0){
      
      for(let i = 0; i < sortingFields.length; i++){
        parsedStructure.push({
          "FieldName": sortingFields[i].Name,
          "SortDirection": sortingFields[i].order === 'asc' ? 0 : 1,
          "RootClassName": rootClassName
        });
      }
    }

    return parsedStructure;
  }

  // this is parsing WG backend sorting for usersearchsetting to view settings sorting tab model
  parseBackendSortToViewSettingsSorting(defaultSorterTextJson: string, availibleSortFields: any[]){
    let existingSortingFields: any[] = [];

    // in backend it's stored as json text
    if(defaultSorterTextJson && defaultSorterTextJson.length > 0){
      // for now its only one object supported
      try{
        let jsonObjectSort = JSON.parse(defaultSorterTextJson);
        if(jsonObjectSort){
          // must exist in availible sort fields
          let index = availibleSortFields.findIndex(x => x.Name === jsonObjectSort.FieldName);

          if(index >= 0){
            existingSortingFields.push({
              "Name": jsonObjectSort.FieldName,
              "Translation": availibleSortFields[index].Translation,
              "order": jsonObjectSort.SortDirection === 0 ? 'asc' : 'desc'
            });
          }          
        }
      }catch{}      
    }


    return existingSortingFields;
  }

  parseMultipleFieldPropertyBinding(propertyPathNested: string|undefined, propertyBinding: string, replaceDots:boolean){    
    // change row.PropertyBinding if needed (in case of nested properties)
    // but only change if propPath is not empty (in that case property is nested)
    if(propertyPathNested && propertyPathNested.length > 0){                  
      let nestedPropPath = propertyPathNested + "." + propertyBinding;
      
      if(replaceDots === true){
        // we must replace "." with "_"
        nestedPropPath = nestedPropPath.replace(/\./g, '_');
      }      
      return nestedPropPath;
    }

    return propertyBinding;
  }

  private extractDateFromAddDays(stringValue: string){
    if(stringValue){
      const firstQuoteIndex = stringValue.indexOf("'");
      const secondQuoteIndex = stringValue.indexOf("'", firstQuoteIndex + 1);
      
      if (firstQuoteIndex !== -1 && secondQuoteIndex !== -1) {
          // Extract the date part using substring
          const datePart = stringValue.substring(firstQuoteIndex + 1, secondQuoteIndex);
          return datePart;
      }
    }

    return null;
  }
}
